import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { RecaptchaVerifier, signInWithPhoneNumber } from "firebase/auth";
import {
  getRedirectResult,
  signInWithPopup,
  signInWithRedirect,
} from "firebase/auth";
import { auth, provider, appleProvider } from "../../firebase";

import { TextInput, MobileInput } from "../../components";
import { loginValidation } from "../../validation/signup";

import { login } from "../../redux/slices/auth/loginSlice";
import Logo from "../../assets/images/Logo.png";
import LoginMask from "../../assets/images/Group jackpot.png";
import Google from "../../assets/images/google 2.svg";
import { loginGoogle } from "../../redux/slices/auth/loginGoogleSlice";
import { setCookies } from "../../helper/utils";

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const configData = useSelector((state) => state.config.data);
  const [error, setError] = useState({});
  const { t } = useTranslation();

  const [form, setForm] = useState({
    contact: "",
    agentCode: "",
    referralCode: "",
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    const { errors, isValid } = loginValidation(form);

    if (!isValid) {
      setError(errors);
    } else {
      dispatch(login(form))
        .unwrap()
        .then((res) => {
          if (res.success) {
            navigate("/email-verification", { state: { id: res.user._id } });
          } else {
            toast.error(res.message);
          }
        })
        .catch((error) => {
          toast.error(error.message);
          // console.error("Failed :", error);
        });
    }
  };

  const handleChange = (e) => {
    const { name, value } = e;

    setForm((prev) => ({ ...prev, [`${name}`]: value }));
    setError((prevState) => ({
      ...prevState,
      [name]: "",
    }));
  };
  const handleChangeText = (e) => {
    const { name, value } = e.target;

    setForm((prev) => ({ ...prev, [`${name}`]: value }));
    setError((prevState) => ({
      ...prevState,
      [name]: "",
    }));
  };

  const handleLogin = async () => {
    try {
      const result = await signInWithPopup(auth, provider);
      const user = result.user;
      const idToken = await user.getIdToken();
      const payload = {
        idToken: idToken,
        // agentCode: "",
        agentCode: form.agentCode
          ? form.agentCode
          : configData?.agentCode || "",
        referralCode: form.referralCode,
      };

      if (configData) {
        dispatch(loginGoogle(payload))
          .unwrap()
          .then((res) => {
            if (res.success) {
              toast.success(res.message);
              setCookies("betfrenzy_token", res.token);
              navigate("/");
            }
          })
          .catch((error) => {
            toast.error(error.message);
            // console.error("Failed :", error);
          });
      } else {
        toast.error("couldn't find Agent code.");
      }
    } catch (error) {
      console.error("Google Sign-In Error:", error);
    }
  };

  useEffect(() => {
    const fetchRedirectResult = async () => {
      try {
        const result = await getRedirectResult(auth);
        if (result) {
          const user = result.user;

          await user.getIdToken();
        }
      } catch (error) {
        console.error("Apple Redirect Error:", error);
      }
    };

    fetchRedirectResult();
  }, []);

  return (
    <div className="p-2 bg-image p-md-4 vh-100">
      <div id="recaptcha-container"></div>

      <div
        className={`row p-2 mx-2 mx-xs-2 mx-sm-2 mx-md-2 mx-lg-0 mx-xl-0 signup-height 
           border-radius-40 bg-dark bg-dark-border`}
        style={{ borderRadius: "60px" }}
      >
        <div
          className={`col-12 col-md-6 order-2 order-md-1 
           shadow bg-white p-4 m-0 align-content-center signup-height
          border-radius-40 bg-purple-dark h-md-auto auth-image-section margin-15`}
          style={{ borderRadius: "50px" }}
        >
          <img
            src={LoginMask}
            alt=""
            className="w-70 d-flex m-auto auth-image"
          />
        </div>
        <div className="col order-1 order-md-2 flex-grow-1 p-4 text-center">
          <div className=" mx-auto mx-md-auto mx-lg-auto col-12 col-md-10 col-lg-8 col-xl-8">
            <img
              src={configData?.website_logo ? configData?.website_logo : Logo}
              alt=""
              className="mb-2 mb-md-2 mb-md-lg-2 mb-xl-5"
              style={{ maxHeight: "50px", width: "auto" }}
            />
            <h2 className="mb-2 hero-heading">{t("welcome", { name: "" })}</h2>
            <p className="text-white mb-2 mb-md-2 mb-lg-2 mb-xl-4">
              {t("subTitle")}
            </p>

            <form onSubmit={handleSubmit}>
              <MobileInput
                name={"contact"}
                title={t("SignUpPage.phoneNumber")}
                type={"contact"}
                value={form.contact}
                error={error.contact}
                handleChange={handleChange}
                placeholder={t("Placeholder.phone")}
                page={"login"}
              />

              <div className="mt-3">
                <div className="my-2 mb-4 ">
                  <button
                    type="submit"
                    className="btn-purple btn-purple-shadow btn col-12 py-2 fw-semibold"
                    onClick={(e) => {
                      // e.preventDefault();
                      handleSubmit(e);
                    }}
                  >
                    <span className=" text-white-btn text-uppercase">
                      {t("signIn")}
                    </span>
                  </button>
                </div>

                <span className="text-white fs-14">{t("or")}</span>
                <div className="my-2 my-md-2 my-lg-2 my-xl-3 ">
                  <TextInput
                    name={"referralCode"}
                    title={t("SignUpPage.referralCode")}
                    type={"text"}
                    value={form.referralCode}
                    // error={error.referralCode}
                    handleChange={handleChangeText}
                    placeholder={t("Placeholder.referralCode")}
                    // page={"signup"}
                  />

                  <TextInput
                    name={"agentCode"}
                    title={t("SignUpPage.agentCode")}
                    type={"text"}
                    value={form.agentCode}
                    // error={error.agentCode}
                    handleChange={handleChangeText}
                    placeholder={t("Placeholder.agent")}
                    page={"signup"}
                  />

                  <div
                    className="p-2 social-logo rounded-2 my-2 my-md-2 my-lg-2 my-xl-3 cursor-pointer d-flex align-items-center"
                    onClick={handleLogin}
                  >
                    <div className="flex-shrink-0 me-2">
                      <img
                        draggable="false"
                        loading="lazy"
                        src={Google}
                        alt="Google"
                        className="google-icon"
                      />
                    </div>
                    <div className="flex-grow-1 text-center w-100">
                      <span className="text-white">Sign In with Google</span>
                    </div>
                  </div>
                </div>

                <span className=" ps-2 fs-12 form-label">
                  {t("dontHaveAcc")}{" "}
                  <span
                    className="cursor-pointer text-purple fw-semibold"
                    onClick={() => {
                      navigate("/signup");
                    }}
                  >
                    {t("signUp")}{" "}
                  </span>
                </span>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Login;
